import IntegrationsService from '@/api/IntegrationsService.js'
import Vue from 'vue'
export const integrationsModule = {
  namespaced: true,
  state: () => ({
    integrationsData: [],
    integrationsLoadStatus: 'request',
    paginationPromocodesStateParams: {
      count: 0,
      limit: 5,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationPromocodesStateParams.total /
        state.paginationPromocodesStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.integrationsData = [...data]
    },
    create(state, data) {
      state.integrationsData.unshift(data[0])
    },
    edit_multiple(state, data) {
      let indexed = state.integrationsData.findIndex(
        (x) => x.integrations__id == data.id
      )
      Object.assign(state.integrationsData[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.integrationsData.findIndex(
        (x) => x.integrations__id == id
      )
      state.integrationsData.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationPromocodesStateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.integrationsLoadStatus = 'request'
    },
    load_success(state) {
      state.integrationsLoadStatus = 'success'
    },
    load_error(state) {
      state.integrationsLoadStatus = 'error'
    }
  },
  actions: {
    getIntegrationsAll({ commit }, params) {
      commit('load_request')

      IntegrationsService.getAll(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createIntegrationsData({ commit }, createData) {
      IntegrationsService.create(createData)
        .then((data) => {
          commit('create', data.data.data.rows)
          Vue.$toast.success('Запись добавлена')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    editIntegrationsMultiple({ commit }, { id, dataEdit }) {
      IntegrationsService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteIntegrationsData({ commit }, id) {
      // commit("load_request");
      IntegrationsService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
